export default __webpack_public_path__ + "static/media/QnA.d265e1dc.png";